export const CURRENCIES = [
  { id: "eur", code: "EUR", name: "Euro",         flag: "🇪🇺", color: "#60a5fa", accent: "#3b82f6" },
  { id: "gbp", code: "GBP", name: "Pound",        flag: "🇬🇧", color: "#a78bfa", accent: "#8b5cf6" },
  { id: "jpy", code: "JPY", name: "Yen",          flag: "🇯🇵", color: "#f87171", accent: "#ef4444" },
  { id: "inr", code: "INR", name: "Rupee",        flag: "🇮🇳", color: "#fb923c", accent: "#f97316" },
  { id: "cad", code: "CAD", name: "CAD Dollar",   flag: "🇨🇦", color: "#f472b6", accent: "#ec4899" },
  { id: "aud", code: "AUD", name: "AUD Dollar",   flag: "🇦🇺", color: "#34d399", accent: "#10b981" },
  { id: "chf", code: "CHF", name: "Swiss Franc",  flag: "🇨🇭", color: "#fbbf24", accent: "#f59e0b" },
];

export const METALS = [
  { id: "gold",      symbol: "XAU", name: "Gold",      karat: "24K", color: "#FFD700", bg: "#1a1400", accent: "#FFB800", icon: "◈" },
  { id: "silver",    symbol: "XAG", name: "Silver",    karat: "24K", color: "#C0C0C0", bg: "#0d0d10", accent: "#A8A8B8", icon: "◇" },
  { id: "platinum",  symbol: "XPT", name: "Platinum",  karat: "24K", color: "#E5E4E2", bg: "#0a0f14", accent: "#8ECAE6", icon: "◆" },
  { id: "palladium", symbol: "XPD", name: "Palladium", karat: "24K", color: "#CED0DD", bg: "#100a14", accent: "#C77DFF", icon: "◉" },
];
